import { createClient } from '@supabase/supabase-js'

const SUPABASE_URL = "https://wtuzpyymqslhzjoxwgxi.supabase.co"
const SUPABASE_ANON_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Ind0dXpweXltcXNsaHpqb3h3Z3hpIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzQ2MzQ4MjIsImV4cCI6MjA5MDIxMDgyMn0.4rMpMeJ3MeVvv3DswQj4CHcmdTcvtYycSP_1oHc9fnE"

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY)